import React, { useEffect, useState } from "react";
import { Grid, Typography, Paper, Chip } from "@mui/material";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import { sweetStatusAlert } from "../../../../../components/common/SweetAlert";
import { namespace } from "../../../../../helper/namespace";
import config from "../../../../../helper/config";

const RegBStaffDocSubmission = ({ handleUploadFiles, disbaleAllApplicatInputs }) => {
    const [selectedFiles, setSelectedFiles] = useState([]); // Single list of files

    const nameCheckForFileUpload = (file) => {
        const isHaveSameName = selectedFiles.some(file_ => file[0].name === file_[0].name);
        if (isHaveSameName) {
            sweetStatusAlert(namespace.FAILED, `File names are similar`, "error");
            return true;
        }
        return false;
    };

    const sizeCheckForFileUpload = (file) => {
        if (file[0].size > config.fileUploadConfigs.maxFileSize) {
            const maxFileSizeInGB = (config.fileUploadConfigs.maxFileSize / (1024 * 1024));
            sweetStatusAlert(namespace.FAILED, `The maximum file size of ${maxFileSizeInGB}GB has been exceeded. Check the size of the file ${file[0].name}!`, "error")            
            return true;
        }
        return false;
    };

    const handleSelectedFiles = (e) => {
        const { files } = e.target;

        if (sizeCheckForFileUpload(files) || nameCheckForFileUpload(files)) {
            return;
        }
        setSelectedFiles([...selectedFiles, files]); // Update single list of files
    };

    useEffect(() => {
        console.log("selectedFiles", selectedFiles);
        handleUploadFiles(selectedFiles); // Use callback to update parent with files
    }, [selectedFiles]);

    const Item = styled(Paper)(({ theme }) => ({
        ...theme.typography.body2,
        textAlign: "center",
        color: theme.palette.text.secondary,
        lineHeight: "40px",
        padding: theme.spacing(2),
        marginBottom: theme.spacing(1),
        marginRight: theme.spacing(3),
    }));

    const truncateFileName = (fileName) => {
        const maxLength = 25;
        if (fileName?.length > maxLength) {
            return "..." + fileName.substring(fileName.length - maxLength);
        }
        return fileName;
    };

    const concatText = () => {
        return selectedFiles.map((file) => file[0].name).join(', ');
    };

    const uploadComponent = () => (
        <Item elevation={0} sx={{ pl: 5, pr: 5 }}>
            <div className="row align-items-center">
                <div className="col-3">
                    <Typography variant="body1" sx={{ textAlign: "left" }}>
                        Staff member documents:
                    </Typography>
                </div>
                <div className="col-9">
                    <div>
                        <label
                            htmlFor="fileInput"
                            className="custom-file-label"
                        >
                            {selectedFiles.length
                                ? `${truncateFileName(selectedFiles[0][0]?.name)}${selectedFiles.length > 1 ? ' + ' + (selectedFiles.length - 1) : ''}`
                                : "Select a file"}
                        </label>
                        <input
                            title={concatText()}
                            type="file"
                            onChange={handleSelectedFiles}
                            className="custom-file-input"
                            style={{ width: "100%", cursor: 'pointer' }}
                            disabled={disbaleAllApplicatInputs}
                        />
                    </div>
                    {selectedFiles.length > 0 && selectedFiles.map((file, index) => (
                        <Chip
                            disabled={disbaleAllApplicatInputs}
                            key={index}
                            label={truncateFileName(file[0]?.name)}
                            variant="outlined"
                            onDelete={() => {
                                const updatedFiles = [...selectedFiles];
                                updatedFiles.splice(index, 1);
                                setSelectedFiles(updatedFiles);
                            }}
                            sx={{ marginTop: 1, marginRight: 1 }}
                        />
                    ))}
                </div>
            </div>
        </Item>
    );

    return (
        <Grid container spacing={2} sx={{ textAlign: "left" }}>
            <Grid item xs={12}>
                {uploadComponent()}
            </Grid>
        </Grid>
    );
};

export default RegBStaffDocSubmission;
